export default __webpack_public_path__ + "static/media/bruinBear.3a4b3ef7.jpeg";